import Vue from 'vue';

class VueComponentRegistery {
	constructor() {
		this.components = {};

		document.addEventListener("DOMContentLoaded", () => {
			this.initAll();
		});
	}

	register(name, vueComponent, vueStore) {
		Vue.component(name, vueComponent);
		this.components[name] = { 
			component: vueComponent, 
			store: vueStore
		};
	}

	initAll() {
		Object.keys(this.components).forEach(name => {
			let store = this.components[name].store;
			[...document.querySelectorAll(name)].forEach(elem => {
				new Vue({el: elem, store});
			});
		});
	}
}

export default new VueComponentRegistery();
